import axios from 'axios'
import router from '@/router'
// import store from '../store'
import {
    urlencode
} from './common'

export function requestApi(reqUrl, type = 'POST', data = {}, multipart = false, url = false) {
    // let that = this
    // console.log(1111)
    if (!reqUrl) {
        if (!url) {
            return
        }
    }
    let headers = {}
    headers['Content-Type'] = 'application/json'
    if (multipart) {
        headers['Content-Type'] = 'multipart/form-data'
    }
    type = type.toUpperCase()
    // store.state.auth.token&&(headers['token'] = store.state.auth.token);
    // console.log(headers, 'headers')
    // 根地址
    // const env = 'https://datiadmin.houjiangshan.top/app/'
    // const env ='https://datiadmin.houjiangshan.top/app/'
    // const env = 'https://www.xlingchuang.com/app/'
    const env = 'https://www.xlingchuang.com/app/'
    const api = 'https://www.xlingchuang.com/api/'
    // const env = 'https://test.xlingchuang.com/app/'
    // const api = 'https://test.xlingchuang.com/api/'
    // const env = 'http://www.xling.com/app/'
    // const api = 'http://www.xling.com/api/'
    // const env = 'api-local-management/api/v1/'
    if (url) {
        reqUrl = api + url
    } else {
        reqUrl = env + reqUrl
    }
    // console.log(reqUrl, 'reqUrl')
    let axiosData
    if (type === 'POST') {
        axiosData = {
            headers: headers,
            method: type,
            url: reqUrl,
            data: data
        }
    } else {
        if (JSON.stringify(data) !== '{}') {
            reqUrl += '?' + urlencode(data)
        }
        axiosData = {
            headers: headers,
            method: type,
            url: reqUrl
        }
    }
    return new Promise((resolve, reject) => {

        axios(axiosData).then(res => {
            // console.log(res.data, 'res')
            if (res.data.code === 1) {
                resolve(res.data)
                // console.log('200')
            } else {
                if (res.data.code === -4) {
                    router.push({
                        name: 'login',
                        query: {
                            clear: 1
                        }
                    })
                }
                reject(res.data);

            }
        }, error => {
            // console.log(error, 'error')
            if (error.response.status === 401) {
                alert('未获得授权');
            } else if (error.response.status === 601 || error.response.status === 602 || error.response
                .status === 603 || error.response.status === 604 || error.response.status === 605) {
                alert('请重新登陆')
                router.push({
                    name: 'login',
                    query: {
                        clear: 1
                    }
                }) // token过期，需要删除
            } else if (error.response.status === 701) {
                // router.push({ name: 'HomeSellerLogin', query: { clear: 1 } })// token过期，需要删除
                alert('系统忙，请稍后再试')
                return;
            } else if (error.response.status === 503) {
                alert('服务不可用')
            } else {
                reject(error)
            }
        })
    })
}

export function requestRaw(reqUrl, type = 'POST', data = {}) {
    type = type.toUpperCase()
    let axiosData
    if (type === 'POST') {
        axiosData = {
            method: type,
            url: reqUrl,
            data: data
        }
    } else {
        if (JSON.stringify(data) !== '{}') {
            reqUrl += '?' + urlencode(data)
        }
        axiosData = {
            method: type,
            url: reqUrl
        }
    }
    return new Promise((resolve, reject) => {
        axios(axiosData).then(res => {
            resolve(res.data)
        }, error => {
            reject(error)
        })
    })
}
